<div class="bpx-dialog">
    <h2 mat-dialog-title>{{data.title}}</h2>
    <mat-dialog-content>
        {{data.message}}
    </mat-dialog-content>
    <mat-dialog-actions>
        <!-- Compulsory Dismiss Button -->
        <button matRipple class="bpx-btn bpx-btn--primary" [mat-dialog-close] (click)="data.okAction()">{{data.okText || 'OK'}}</button>
        <!-- Optional Action -->
         @if (data && data.dismissText) {
            <button matRipple class="bpx-btn" [mat-dialog-close] (click)="data.dismissAction()">
                {{data.dismissText}}
            </button>
        }
    </mat-dialog-actions>
</div>
